// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"413":"e0924093","566":"c1625a30"}[chunkId] + ".chunk.js";
};